import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => { if (!localStorage.getItem("cp_cookie_ok")) setShow(true); }, 1500);
    return () => clearTimeout(t);
  }, []);
  const accept = () => { localStorage.setItem("cp_cookie_ok", "1"); localStorage.setItem("cp_cookie_consent", "all"); setShow(false); };
  const decline = () => { localStorage.setItem("cp_cookie_ok", "1"); localStorage.setItem("cp_cookie_consent", "essential"); setShow(false); };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-[55] bg-navy text-white px-5 py-4 sm:py-5"
        >
          <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
            <div className="flex items-start gap-3">
              <Cookie className="w-5 h-5 text-gold mt-0.5 shrink-0" strokeWidth={1.5} />
              <p className="text-sm text-white/80 leading-relaxed max-w-2xl">
                We use strictly necessary, analytics, and functionality cookies to operate and improve this site. By clicking Accept, you consent to non-essential cookies. See our <Link to="/privacy" data-testid="cookie-privacy-link" className="text-gold underline underline-offset-2 hover:text-white">Privacy Policy</Link>.
              </p>
            </div>
            <div className="flex gap-3 shrink-0">
              <button data-testid="cookie-decline" onClick={decline} className="text-sm text-white/60 hover:text-white px-4 py-2 transition-colors">Decline</button>
              <button data-testid="cookie-accept" onClick={accept} className="bg-gold text-navy text-sm font-600 px-6 py-2.5 hover:bg-white transition-colors">Accept</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
